import { customAlphabet } from "nanoid";

function generate(alphabet: string, length = 21) {
  const nanoid = customAlphabet(alphabet, length);

  return nanoid();
}

export function generateRandomNumber(length: number) {
  const alphabet = "123456789";

  return generate(alphabet, length);
}

export function generateRandomId(namespace: string | null = null, length = 21) {
  const alphabet =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const prefix = namespace ? namespace + "_" : "";
  return prefix + generate(alphabet, length);
}

export function generateLowercaseId(
  namespace: string | null = null,
  length = 21
) {
  const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
  const prefix = namespace ? namespace + "_" : "";
  return prefix + generate(alphabet, length);
}

export function generateShortToken(length = 9) {
  const alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
  return generate(alphabet, length);
}
